import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import { cpfMaskView, telefoneMask } from 'utils/masks';
import * as S from './styles';
import { separarEmail } from 'utils/formUtils';

export default function Pessoa({ dados }) {
  return (
    <>
      <Row>
        <S.ContainerLabelValor>
          <S.Label>Tipo de pessoa</S.Label>
          <S.Valor>{dados?.tipoPessoa}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Nome</S.Label>
          <S.Valor>{dados?.nome}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Nome Social</S.Label>
          <S.Valor>{dados?.nomeSocial}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>CPF</S.Label>
          <S.Valor>{cpfMaskView(dados?.cpf)}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Data de Nascimento</S.Label>
          <S.Valor>{dados?.dataNascimento}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Sexo</S.Label>
          <S.Valor>{dados?.sexo}</S.Valor>
        </S.ContainerLabelValor>
      </Row>

      <Row>
        <S.ContainerLabelValor>
          <S.Label>E-mail</S.Label>
          <S.Valor>{separarEmail(dados?.email)}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Telefone</S.Label>
          <S.Valor>{telefoneMask(dados?.telefone)}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Escolaridade</S.Label>
          <S.Valor>{dados?.escolaridade}</S.Valor>
        </S.ContainerLabelValor>

        <S.ContainerLabelValor>
          <S.Label>Profissão</S.Label>
          <S.Valor>{dados?.profissao}</S.Valor>
        </S.ContainerLabelValor>
      </Row>
    </>
  );
}

Pessoa.propTypes = {
  dados: PropTypes.object,
};
